import { addAddonsToSelectedItems } from 'app/pages/TicketSalePage/slice';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectEventFromCart } from 'store/cartSlice/selectors';
import TicketAddon from '../TicketSection/TicketAddon';

interface AddonsListProps {
  ticketId: string;
  ticketIndex: number;
  ticketDate: string | undefined;
  bundleId: string | undefined;
}

const AddonsList: React.FC<AddonsListProps> = ({
  ticketId,
  ticketIndex,
  ticketDate,
  bundleId,
}) => {
  const dispatch = useDispatch();
  const selectedEvent = useSelector(selectEventFromCart);

  const ticket = selectedEvent.tickets.find(({ id }) => id === ticketId)!;
  const addons = ticket.ticketaddons.filter(
    ({ is_bundled }) => is_bundled === 0,
  );

  const absorbFees = bundleId
    ? selectedEvent.ticketTypeBundles!.find(({ id }) => id === bundleId)!
        .absorbFees
    : ticket.ticketprice[0].absorb_fees;

  return addons && addons.length > 0 ? (
    <div className="bg-neutral-10 rounded-md">
      {addons.map(addon => (
        <TicketAddon
          key={addon.id}
          ticketId={ticketId}
          ticketIndex={ticketIndex}
          addon={addon}
          displayFee={!absorbFees}
          currency={selectedEvent.currency}
          addAddonToCart={(ticketId, addonId, quantity) => {
            dispatch(
              addAddonsToSelectedItems({
                event: selectedEvent,
                addon: {
                  addonId,
                  ticketIndex,
                  ticketId,
                  ticketDate,
                  quantity,
                  absorbFees,
                },
              }),
            );
          }}
        />
      ))}
    </div>
  ) : null;
};

export default AddonsList;
